module.exports = __webpack_public_path__ + "static/img/certificate.8194d6e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/certificate.png
// module id = Z4yT
// module chunks = 1